import React from 'react';
import { palette } from '../../styles/theme';

export function CrossSVG ({ customStroke = palette.secondary[600], className = '', selected = false }) {
    return (
        <span className={className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_6854_11270)">
                    <path d="M18 6L6 18" stroke={customStroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6 6L18 18" stroke={customStroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_6854_11270">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
